<template>
  <div>
    <p class="custom-label">Hauptgabelung:</p>
    <v-row :class="viewOnly ? 'view-only' : ''">
      <v-col cols="3" class="form-element-holder">
        <div>
          <div class="fields one-line">
            <v-checkbox
              v-model="treeExaminationCrownBase.harmonious"
              hide-details
              label="Stabil/gut verwachsen*"
              class="custom-checkbox"
              :rules="[checkAtLeastOneSelected]"
              :class="atLeastOne ? '' : 'error--text'"
            ></v-checkbox>
          </div>
        </div>
      </v-col>
      <v-col cols="3" class="form-element-holder">
        <div>
          <div class="fields">
            <v-checkbox
              v-model="treeExaminationCrownBase.vBifurcation"
              hide-details
              label="V-Gabelung"
              class="custom-checkbox"
            ></v-checkbox>
          </div>
        </div>
      </v-col>
      <v-col cols="3" class="form-element-holder">
        <div>
          <div class="fields">
            <v-checkbox
              v-model="treeExaminationCrownBase.ingrownBark"
              hide-details
              label="mit eingewachsener Rinde"
              class="custom-checkbox"
            ></v-checkbox>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row :class="viewOnly ? 'view-only' : ''">
      <v-col cols="3" class="form-element-holder">
        <div>
          <div class="fields one-line">
            <v-checkbox
              v-model="treeExaminationCrownBase.secured"
              hide-details
              label="gesichert"
              class="custom-checkbox"
            ></v-checkbox>
            <v-select
              v-if="treeExaminationCrownBase.secured"
              v-model="treeExaminationCrownBase.throughCutId"
              :items="throughCutOptions"
              item-text="name"
              item-value="value"
              outlined
              hide-details
              clearable
            >
              <v-icon slot="append" color="white">
                mdi-chevron-down
              </v-icon>
            </v-select>
          </div>
        </div>
      </v-col>

      <v-col cols="3" class="form-element-holder">
        <div>
          <div class="fields">
            <v-checkbox
              v-model="treeExaminationCrownBase.damagedAreas"
              hide-details
              label="Schadstellen"
              class="custom-checkbox"
              @click="toggleAccordion()"
            ></v-checkbox>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- from here are new -->
    <v-row>
      <v-col cols="12">
        <!-- nested expansion panel below -->
        <v-expansion-panels v-model="accordionOpen" multiple>
          <v-expansion-panel class="nested-accordion">
            <v-expansion-panel-header>
              Beschreibung der Schadstellen
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row :class="viewOnly ? 'view-only' : ''">
                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.necrosis"
                        hide-details
                        label="Nekrose"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.wound"
                        hide-details
                        label="Wunde"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.crack"
                        hide-details
                        label="Riss"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.fungalFruitingBody"
                        hide-details
                        label="Pilzfruchtkörper"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.drillHole"
                        hide-details
                        label="Frassgang/Bohrloch"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- necrose -->
              <v-row
                class="root-damage"
                v-show="treeExaminationCrownBase.necrosis"
                v-for="(item, index) in necroseDamage"
                :key="'necrosis' + index"
                :class="viewOnly ? 'view-only' : ''"
              >
                <v-col cols="12" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-title">
                        {{ index + 1 }}. Nekrose:
                        <a
                          href="#"
                          v-if="necroseDamage.length > 1"
                          class="remove-root-dmg"
                          @click.prevent="deleteNecroseDmgContainer(index)"
                          ><span class="mdi mdi-close"></span
                        ></a>
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Richtung:</p>

                      <v-select
                        v-model="item.inputs.selectedDirection"
                        :items="directionItems"
                        outlined
                        hide-details
                        item-text="name"
                        item-value="value"
                        small-chips
                        clearable
                      >
                        <v-icon slot="append" color="white">
                          mdi-chevron-down
                        </v-icon>
                        <template #selection="{ item }">
                          <v-chip color="green" small>{{ item.name }}</v-chip>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </v-col>

                <v-col cols="2" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Höhe:</p>

                      <v-text-field
                        v-model="item.inputs.DmgHeight"
                        type="number"
                        outlined
                        clearable
                        hide-details
                        append-outer-icon="cm"
                        class="number-input"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>

                <v-col cols="2" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Länge:</p>

                      <v-text-field
                        v-model="item.inputs.DmgLength"
                        type="number"
                        outlined
                        clearable
                        hide-details
                        append-outer-icon="cm"
                        class="number-input"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>

                <v-col cols="2" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Breite:</p>

                      <v-text-field
                        v-model="item.inputs.DmgBroad"
                        type="number"
                        outlined
                        clearable
                        hide-details
                        append-outer-icon="cm"
                        class="number-input"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Beschreibung:</p>

                      <v-textarea
                        v-model="item.inputs.DmgDescription"
                        type="text"
                        outlined
                        clearable
                        hide-details
                        auto-grow
                        rows="2"
                      ></v-textarea>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                  <a
                    href="#"
                    class="add-new"
                    @click.prevent="cloneNewNecroseDmg(index)"
                  >
                    <span class="mdi mdi-plus-thick custom-add-icon"></span
                    ><span>Hinzufügen</span>
                  </a>
                </v-col>
              </v-row>

              <!-- riss - crack  -->
              <v-row
                class="root-damage"
                v-show="treeExaminationCrownBase.crack"
                v-for="(item, index) in crackDamage"
                :key="'crack' + index"
                :class="viewOnly ? 'view-only' : ''"
              >
                <v-col cols="12" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-title">
                        {{ index + 1 }}. Riss:
                        <a
                          href="#"
                          v-if="crackDamage.length > 1"
                          class="remove-root-dmg"
                          @click.prevent="deleteCrackDmgContainer(index)"
                          ><span class="mdi mdi-close"></span
                        ></a>
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Richtung:</p>

                      <v-select
                        v-model="item.inputs.selectedDirection"
                        :items="directionItems"
                        outlined
                        hide-details
                        item-text="name"
                        item-value="value"
                        small-chips
                        clearable
                      >
                        <v-icon slot="append" color="white">
                          mdi-chevron-down
                        </v-icon>
                        <template #selection="{ item }">
                          <v-chip color="green" small>{{ item.name }}</v-chip>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </v-col>

                <v-col cols="2" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Höhe:</p>

                      <v-text-field
                        v-model="item.inputs.DmgHeight"
                        type="number"
                        outlined
                        clearable
                        hide-details
                        append-outer-icon="cm"
                        class="number-input"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>

                <v-col cols="2" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Länge:</p>

                      <v-text-field
                        v-model="item.inputs.DmgLength"
                        type="number"
                        outlined
                        clearable
                        hide-details
                        append-outer-icon="cm"
                        class="number-input"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>

                <v-col cols="2" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Breite:</p>

                      <v-text-field
                        v-model="item.inputs.DmgBroad"
                        type="number"
                        outlined
                        clearable
                        hide-details
                        append-outer-icon="cm"
                        class="number-input"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Beschreibung:</p>

                      <v-textarea
                        v-model="item.inputs.DmgDescription"
                        type="text"
                        outlined
                        clearable
                        hide-details
                        auto-grow
                        rows="2"
                      ></v-textarea>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                  <a
                    href="#"
                    class="add-new"
                    @click.prevent="cloneNewCrackDmg(index)"
                  >
                    <span class="mdi mdi-plus-thick custom-add-icon"></span
                    ><span>Hinzufügen</span>
                  </a>
                </v-col>
              </v-row>
  <!-- wound -->
               <v-row
                  class="root-damage"
                  v-show="treeExaminationCrownBase.wound"
                  v-for="(item, index) in woundDamage"
                  :key="'wound' + index"
                  :class="viewOnly ? 'view-only' : ''"
                >
                  <v-col cols="12" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <p class="custom-title">
                          {{ index + 1 }}. Wunde:
                          <a
                            href="#"
                            v-if="woundDamage.length > 1"
                            class="remove-root-dmg"
                            @click.prevent="deleteWoundDmgContainer(index)"
                            ><span class="mdi mdi-close"></span
                          ></a>
                        </p>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="3" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <p class="custom-label">Richtung:</p>

                        <v-select
                          v-model="item.inputs.selectedDirection"
                          :items="directionItems"
                          outlined
                          hide-details
                          item-text="name"
                          item-value="value"
                          small-chips
                          clearable
                        >
                          <v-icon slot="append" color="white">
                            mdi-chevron-down
                          </v-icon>
                          <template #selection="{ item }">
                            <v-chip color="green" small>{{ item.name }}</v-chip>
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <p class="custom-label">Höhe:</p>

                        <v-text-field
                          v-model="item.inputs.DmgHeight"
                          type="number"
                          outlined
                          clearable
                          hide-details
                          append-outer-icon="m"
                          class="number-input"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <p class="custom-label">Länge:</p>

                        <v-text-field
                          v-model="item.inputs.DmgLength"
                          type="number"
                          outlined
                          clearable
                          hide-details
                          append-outer-icon="cm"
                          class="number-input"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <p class="custom-label">Breite:</p>

                        <v-text-field
                          v-model="item.inputs.DmgBroad"
                          type="number"
                          outlined
                          clearable
                          hide-details
                          append-outer-icon="cm"
                          class="number-input"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="3" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <p class="custom-label">Beschreibung:</p>

                        <v-textarea
                          v-model="item.inputs.DmgDescription"
                          type="text"
                          outlined
                          clearable
                          hide-details
                          auto-grow
                          rows="2"
                        ></v-textarea>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <p class="custom-heading">
                      Ausprägung Wundrand:
                    </p>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <v-checkbox
                          v-model="item.inputs.good"
                          hide-details
                          label="gut"
                          class="custom-checkbox"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <v-checkbox
                          v-model="item.inputs.diffuse"
                          hide-details
                          label="diffus"
                          class="custom-checkbox"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <v-checkbox
                          v-model="item.inputs.noReaction"
                          hide-details
                          label="keine Reaktion"
                          class="custom-checkbox"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <v-checkbox
                          v-model="item.inputs.dyingBack"
                          hide-details
                          label="zurücksterbend"
                          class="custom-checkbox"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2" class="form-element-holder">
                    <div>
                      <div class="fields">
                        <v-checkbox
                          v-model="item.inputs.unchanged"
                          hide-details
                          label="unverändert"
                          class="custom-checkbox"
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" class="form-element-holder">
                    <div>
                      <p class="custom-label">Veränderung:</p>

                      <div class="fields">
                        <v-textarea
                          rows="2"
                          outlined
                          auto-grow
                          :counter="maxCharacters"
                          v-model="item.inputs.change"
                        ></v-textarea>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12">
                    <v-divider></v-divider>
                    <a
                      href="#"
                      class="add-new"
                      @click.prevent="cloneNewWoundDmg(index)"
                    >
                      <span class="mdi mdi-plus-thick custom-add-icon"></span
                      ><span>Hinzufügen</span>
                    </a>
                  </v-col>
              </v-row>

              <v-row>
                <v-col cols="4" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Pathogene:</p>

                      <v-select
                        v-model="treeExaminationCrownBase.beetleId"
                        :items="beetleItems"
                        :item-text="item => `${item.abbreviation} - ${item.name}`"
                        item-value="id"
                        outlined
                        clearable
                        hide-details
                        multiple
                        small-chips
                        persistent-hint
                      >
                        <v-icon slot="append" color="white">
                          mdi-chevron-down
                        </v-icon>
                        <template #selection="{ item }">
                          <v-chip color="green" small>{{ item.name }}</v-chip>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Parasiten:</p>

                      <v-autocomplete
                        v-model="treeExaminationCrownBase.parasitId"
                        :items="parasitItems"
                        :item-text="item => `${item.name} - ${item.latinName} - ${item.germanName}`"
                        item-value="id"
                        outlined
                        hide-details
                        clearable
                        multiple
                        small-chips
                        persistent-hint
                        label="Suche"
                      >
                        <v-icon slot="append" color="white">
                          mdi-chevron-down
                        </v-icon>
                        <template #selection="{ item }">
                          <v-chip color="green" small>{{
                            item.germanName
                          }}</v-chip>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Holzpilze:</p>

                      <v-autocomplete
                        v-model="treeExaminationCrownBase.mushroomTypeId"
                        :items="mushroomItems"
                        :item-text="item => `${item.abbreviation} - ${item.latinName} - ${item.germanName}`"
                        item-value="id"
                        hide-details
                        outlined
                        clearable
                        multiple
                        small-chips
                        persistent-hint
                        label="Suche"
                      >
                        <v-icon slot="append" color="white">
                          mdi-chevron-down
                        </v-icon>
                        <template #selection="{ item }">
                          <v-chip color="green" small>{{
                            item.germanName
                          }}</v-chip>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row :class="viewOnly ? 'view-only' : ''">
                <v-col cols="12" class="form-element-holder">
                  <div>
                    <p class="custom-label">Bemerkungen:</p>

                    <div class="fields">
                      <v-textarea
                        rows="2"
                        outlined
                        auto-grow
                        :counter="maxCharacters"
                        v-model="treeExaminationCrownBase.remarks"
                      ></v-textarea>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- <v-row :class="viewOnly ? 'view-only' : ''">
                <v-col cols="12">
                  <p class="custom-heading">
                    Ausprägung Wundrand:
                  </p>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.good"
                        hide-details
                        label="gut"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.diffuse"
                        hide-details
                        label="diffus"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.noReaction"
                        hide-details
                        label="keine Reaktion"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="3" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.dyingBack"
                        hide-details
                        label="zurücksterbend"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row :class="viewOnly ? 'view-only' : ''">
                <v-col cols="4" class="form-element-holder">
                  <div>
                    <p class="custom-label">Beschreibung:</p>

                    <div class="fields">
                      <v-textarea
                        rows="2"
                        outlined
                        auto-grow
                        :counter="maxCharacters"
                        v-model="treeExaminationCrownBase.description"
                      ></v-textarea>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <v-checkbox
                        v-model="treeExaminationCrownBase.unchanged"
                        hide-details
                        label="unverändert"
                        class="custom-checkbox"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" class="form-element-holder">
                  <div>
                    <p class="custom-label">Veränderung:</p>

                    <div class="fields">
                      <v-textarea
                        rows="2"
                        outlined
                        auto-grow
                        :counter="maxCharacters"
                        v-model="treeExaminationCrownBase.change"
                      ></v-textarea>
                    </div>
                  </div>
                </v-col>
              </v-row> -->

              <v-row :class="viewOnly ? 'view-only' : ''">
                <v-col cols="6" class="form-element-holder">
                  <div>
                    <div class="fields">
                      <p class="custom-label">Foto:</p>
                    </div>

                    <v-row
                      class="preview-images"
                      v-if="treeExaminationCrownBase.crownBaseImages.length > 0"
                    >
                      <v-col
                        cols="2"
                        v-for="(image, index) in treeExaminationCrownBase.crownBaseImages"
                        :key="'crown-base-' + index">
                        <v-img
                          :src="getImageSrc(image)"
                          class="custom-preview-image"
                          cover
                          aspect-ratio="1"
                        >
                          <v-btn
                            class="remove-image-preview"
                            tile
                            width="20"
                            color="error"
                            @click="removeTrunkImage(index)"
                          >
                            <v-icon size="16">mdi mdi-close</v-icon>
                          </v-btn>
                        </v-img>
                        <p >{{ image.fileName }}</p>
                      </v-col>
                    </v-row>
                    <div class="upload-buttons">
                      <input
                      type="file"
                      accept="image/*"
                      capture="camera"
                      @change="handleFileChange"
                      ref="fileInput"
                      multiple
                      style="display: none;"
                    />
                    <div class="custom-file-input" @click="openFileInput">
                      <img
                        src="../../assets/images/icons/upload-gallery-image.svg"
                        alt="Upload Icon"
                        class="custom-upload-icon"
                      />
                    </div>
                      <input
                      type="file"
                      accept="image/*"
                      capture="camera"
                      @change="handleFileChange"
                      multiple
                      ref="fileInput"
                      style="display: none;"
                    />
                    <div class="custom-file-input" @click="openFileInput">
                      <img
                        src="../../assets/images/icons/upload-camera-image.svg"
                        alt="Upload Icon"
                        class="custom-upload-icon"
                      />
                    </div>
                  </div>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import DamageAreaTypes from "@/consts/damageAreaTypes";
import DirectionTypes from "@/consts/directionTypes";
export default {
  props: ["initialData", "viewOnly", "atLeastOne"],
  data() {
    return {
      maxCharacters: 150,
      accordionOpen: [],
      hasClass: false,
      treeExaminationCrownBase: {
        harmonious: false,
        vBifurcation: false,
        ingrownBark: false,
        // withCrack: false,
        secured: false,
        throughCutId: 0,
        damagedAreas: false,

        /* from here are new */
        necrosis: false,
        wound: false,
        crack: false,
        fungalFruitingBody: false,
        drillHole: false,
        beetleId: [],
        parasitId: [],
        mushroomTypeId: [],
        remarks: "",
        crownBaseNecrosisDamagedAreaDetails: [],
        crownBaseCrackDamagedAreaDetails: [],
        crownBaseWoundDamagedAreaDetails:[],
        crownBaseImages: [],

      },
      throughCutOptions: [
        { name: 'Durch Schnitt', value: 1 },
        { name: 'Durch Verankerung', value: 2 },
      ],
      directionItems: DirectionTypes,

      necroseDamage: [
        {
          inputs: {
            selectedDirection: null,
            DmgHeight: null,
            DmgLength: null,
            DmgBroad: null,
            DmgDescription: null
          },
          classes: [
            {
              class: "root-damage"
            }
          ],
          isDuplicatedWith: null
        }
      ],

      crackDamage: [
        {
          inputs: {
            selectedDirection: null,
            DmgHeight: null,
            DmgLength: null,
            DmgBroad: null,
            DmgDescription: null
          },
          classes: [
            {
              class: "root-damage"
            }
          ],
          isDuplicatedWith: null
        }
      ],
      woundDamage: [
        {
          inputs: {
            selectedDirection: null,
            DmgHeight: null,
            DmgLength: null,
            DmgBroad: null,
            DmgDescription: null,
            good: false,
            diffuse: false,
            noReaction: false,
            dyingBack: false,
            unchanged: false,
            change: ""
          },
          classes: [
            {
              class: "root-damage"
            }
          ],
          isDuplicatedWith: null
        }
      ],
      selectedCrownBaseImages: [],
      beetleItems: [],
      parasitItems: [],
      mushroomItems: []
    };
  },
  watch: {
    object: {
      handler: function(val) {
        if (val) {
          this.$emit("fourthAccordion", val);
        }
      },
      deep: true
    },
    checkAtLeastOneSelected: {
      handler: function(val, oldVal) {
        if (val) {
          this.$emit("checkbox-updated", val);
        }
      },
    },

    necroseDamage: {
      handler: function(newVal) {
        this.updateTrunkDamagedAreaNecrose(newVal);
      },
      deep: true
    },
    crackDamage: {
      handler: function(newVal) {
        this.updateTrunkDamagedAreaCrack(newVal);
      },
      deep: true
    },
    woundDamage:{
      handler: function(newVal) {
        this.updateTrunkDamagedAreaWound(newVal);
      },
      deep: true
    },
    "treeExaminationCrownBase.necrosis": function(newValue, oldValue) {
      if (newValue === false) {
        /* remove all necroseDamage items except index 0 */
        this.necroseDamage = this.necroseDamage.slice(0, 1);

        /* reset it */
        this.necroseDamage[0].inputs = {
          selectedDirection: null,
          DmgHeight: null,
          DmgLength: null,
          DmgBroad: null,
          DmgDescription: null
        };

        /* reset original object to empty array using nextTick */
        this.$nextTick(() => {
          this.treeExaminationCrownBase.crownBaseNecrosisDamagedAreaDetails = [];
        });
      }
    },
    "treeExaminationCrownBase.crack": function(newValue, oldValue) {
      if (newValue === false) {
        /* remove all necroseDamage items except index 0 */
        this.crackDamage = this.crackDamage.slice(0, 1);

        /* reset it */
        this.crackDamage[0].inputs = {
          selectedDirection: null,
          DmgHeight: null,
          DmgLength: null,
          DmgBroad: null,
          DmgDescription: null
        };

        /* reset original object to empty array using nextTick */
        this.$nextTick(() => {
          this.treeExaminationCrownBase.crownBaseCrackDamagedAreaDetails = [];
        });
      }
    },
    "treeExaminationCrownBase.wound": function(newValue, oldValue) {
      if (newValue === false) {
        /* remove all necroseDamage items except index 0 */
        this.woundDamage = this.woundDamage.slice(0, 1);

        /* reset it */
        this.woundDamage[0].inputs = {
          selectedDirection: null,
          DmgHeight: null,
          DmgLength: null,
          DmgBroad: null,
          DmgDescription: null,
          good: false,
          diffuse: false,
          noReaction: false,
          dyingBack: false,
          unchanged: false,
          change: ""
        };

        /* reset original object to empty array using nextTick */
        this.$nextTick(() => {
          this.treeExaminationCrownBase.crownBaseWoundDamagedAreaDetails = [];
        });
      }
    }
  },
  computed: {
    hasTrueValue() {
      for (const key in this.treeExaminationCrownBase) {
        if (this.treeExaminationCrownBase[key] === true) {
          return true;
        }
      }
      return false;
    },
    checkAtLeastOneSelected(v) {
      if (!this.treeExaminationCrownBase.harmonious && !this.hasTrueValue) {
      return 'You must select at least one option!';

      }
      return true;
    },
    object() {
      return this.treeExaminationCrownBase;
    }
  },
  mounted() {
    this.fetchBeetleOptions();
    this.fetchParasitOptions();
    this.fetchMushroomOptions();

    this.treeExaminationCrownBase = { ...this.initialData };

    /* prepopulate crackDamage if there are on initial data */
    if (
      this.treeExaminationCrownBase.crownBaseCrackDamagedAreaDetails.length > 0) {
      /* make it empty then popullate */
      this.crackDamage = [];
      this.treeExaminationCrownBase.crownBaseCrackDamagedAreaDetails.forEach(
        (element, index) => {
          const newItem = {
            inputs: {
              selectedDirection: element.directionTypeId,
              DmgHeight: element.height,
              DmgLength: element.length,
              DmgBroad: element.width,
              DmgDescription: element.description
            },
            classes: [
              {
                class: "root-damage"
              }
            ],
            isDuplicatedWith: null
          };

          this.crackDamage.push(newItem);
        }
      );
    }

    /* prepopulate necroseDamage if there are on initial data */
    if (
      this.treeExaminationCrownBase.crownBaseNecrosisDamagedAreaDetails.length >
      0
    ) {
      /* make it empty then popullate */
      this.necroseDamage = [];
      this.treeExaminationCrownBase.crownBaseNecrosisDamagedAreaDetails.forEach(
        (element, index) => {
          const newItem = {
            inputs: {
              selectedDirection: element.directionTypeId,
              DmgHeight: element.height,
              DmgLength: element.length,
              DmgBroad: element.width,
              DmgDescription: element.description
            },
            classes: [
              {
                class: "root-damage"
              }
            ],
            isDuplicatedWith: null
          };

          this.necroseDamage.push(newItem);
        }
      );
    }
    if (this.treeExaminationCrownBase.crownBaseWoundDamagedAreaDetails.length > 0) {
      /* make it empty then popullate */
      this.woundDamage = [];
      this.treeExaminationCrownBase.crownBaseWoundDamagedAreaDetails.forEach(
        (element, index) => {
          const newItem = {
            inputs: {
              selectedDirection: element.directionTypeId,
              DmgHeight: element.height,
              DmgLength: element.length,
              DmgBroad: element.width,
              DmgDescription: element.description,
              good: element.good,
              diffuse: element.diffuse,
              noReaction: element.noReaction,
              dyingBack: element.dyingBack,
              unchanged: element.unchanged,
              change: element.change
            },
            classes: [
              {
                class: "root-damage"
              }
            ],
            isDuplicatedWith: null
          };

          this.woundDamage.push(newItem);
        }
      );
    }
  },
  methods: {
    toggleAccordion() {
      if (this.treeExaminationCrownBase.damagedAreas) {
        this.accordionOpen = [0]; // Index of the accordion item to open
      } else {
        this.accordionOpen = [];
      }
    },
    deleteNecroseDmgContainer(index) {
      this.necroseDamage = this.necroseDamage.filter((item, i) => i !== index);
    },

    deleteCrackDmgContainer(index) {
      this.crackDamage = this.crackDamage.filter((item, i) => i !== index);
    },
    deleteWoundDmgContainer(index) {
      this.woundDamage = this.woundDamage.filter((item, i) => i !== index);
    },

    cloneNewNecroseDmg(index) {

      /* populate trunkBaseDamagedAreaDetails */

      const newNecroseDmg = {
        damagedAreaTypeId: DamageAreaTypes.CrownBase_Necrosis,
        directionTypeId: this.necroseDamage[index].inputs.selectedDirection || 0,
        height: this.necroseDamage[index].inputs.DmgHeight,
        length: this.necroseDamage[index].inputs.DmgLength,
        width: this.necroseDamage[index].inputs.DmgBroad,
        description: this.necroseDamage[index].inputs.DmgDescription
      };

      this.treeExaminationCrownBase.crownBaseNecrosisDamagedAreaDetails.push(
        newNecroseDmg
      );

      this.necroseDamage.splice(index + 1, 0, {
        inputs: {
          selectedDirection: null,
          DmgHeight: null,
          DmgLength: null,
          DmgBroad: null,
          DmgDescription: null
        },
        classes: [
          {
            class: "root-damage"
          }
        ],
        isDuplicatedWith: null
      });
    },

    cloneNewCrackDmg(index) {

      /* populate trunkBaseDamagedAreaDetails */

      const newCrackDmg = {
        damagedAreaTypeId: DamageAreaTypes.CrownBase_Crack,
        directionTypeId: this.crackDamage[index].inputs.selectedDirection || 0,
        height: this.crackDamage[index].inputs.DmgHeight,
        length: this.crackDamage[index].inputs.DmgLength,
        width: this.crackDamage[index].inputs.DmgBroad,
        description: this.crackDamage[index].inputs.DmgDescription
      };

      this.treeExaminationCrownBase.crownBaseCrackDamagedAreaDetails.push(
        newCrackDmg
      );

      this.crackDamage.splice(index + 1, 0, {
        inputs: {
          selectedDirection: null,
          DmgHeight: null,
          DmgLength: null,
          DmgBroad: null,
          DmgDescription: null
        },
        classes: [
          {
            class: "root-damage"
          }
        ],
        isDuplicatedWith: null
      });
    },

    cloneNewWoundDmg(index) {

      /* populate trunkBaseWoundAreaDetails */

      const newWoundDmg = {
        damagedAreaTypeId: DamageAreaTypes.CrownBase_Wound,
        directionTypeId: this.woundDamage[index].inputs.selectedDirection || 0,
        height: this.woundDamage[index].inputs.DmgHeight,
        length: this.woundDamage[index].inputs.DmgLength,
        width: this.woundDamage[index].inputs.DmgBroad,
        description: this.woundDamage[index].inputs.DmgDescription,
        good: this.woundDamage[index].inputs.good,
        diffuse: this.woundDamage[index].inputs.diffuse,
        noReaction: this.woundDamage[index].inputs.noReaction,
        dyingBack: this.woundDamage[index].inputs.dyingBack,
        unchanged: this.woundDamage[index].inputs.unchanged,
        change: this.woundDamage[index].inputs.change
      };
      this.treeExaminationCrownBase.crownBaseWoundDamagedAreaDetails.push(newWoundDmg);

      this.woundDamage.splice(index + 1, 0, {
        inputs: {
          selectedDirection: null,
          DmgHeight: null,
          DmgLength: null,
          DmgBroad: null,
          DmgDescription: null,
          good: false,
          diffuse: false,
          noReaction: false,
          dyingBack: false,
          unchanged: false,
          change: ""
        },
        classes: [
          {
            class: "root-damage"
          }
        ],
        isDuplicatedWith: null
      });
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          const base64String = e.target.result.split(",")[1]; // Extract the base64 string
          const fileData = {
            document: base64String,
            nameBase64: base64String,
            fileName: file.name,
            fileExtension: file.name.split(".").pop()
          };

          this.treeExaminationCrownBase.crownBaseImages.push(fileData);
        };
      }

      this.selectedRootDamageImages = []; // Clear the selected files after uploading
    },

    removeTrunkImage(index) {
      this.treeExaminationCrownBase.crownBaseImages.splice(index, 1);
      this.selectedCrownBaseImages = [];
    },

    updateTrunkDamagedAreaNecrose(necroseDamage) {
      /* this function prepares data on trunkBaseDamagedAreaDetails handles removing of item aswell */
      this.treeExaminationCrownBase.crownBaseNecrosisDamagedAreaDetails = necroseDamage.map(
        item => {
          return {
            damagedAreaTypeId: DamageAreaTypes.CrownBase_Necrosis,
            directionTypeId: item.inputs.selectedDirection || 0,
            height: item.inputs.DmgHeight,
            length: item.inputs.DmgLength,
            width: item.inputs.DmgBroad,
            description: item.inputs.DmgDescription
          };
        }
      );
    },

    updateTrunkDamagedAreaCrack(crackDamage) {
      this.treeExaminationCrownBase.crownBaseCrackDamagedAreaDetails = crackDamage.map(
        item => {
          return {
            damagedAreaTypeId: DamageAreaTypes.CrownBase_Crack,
            directionTypeId: item.inputs.selectedDirection || 0,
            height: item.inputs.DmgHeight,
            length: item.inputs.DmgLength,
            width: item.inputs.DmgBroad,
            description: item.inputs.DmgDescription
          };
        }
      );
    },
    updateTrunkDamagedAreaWound(woundDamage) {
      this.treeExaminationCrownBase.crownBaseWoundDamagedAreaDetails = woundDamage.map(
        item => {
          return {
            damagedAreaTypeId: DamageAreaTypes.CrownBase_Wound,
            directionTypeId: item.inputs.selectedDirection || 0,
            height: item.inputs.DmgHeight,
            length: item.inputs.DmgLength,
            width: item.inputs.DmgBroad,
            description: item.inputs.DmgDescription,
            good: item.inputs.good,
            diffuse: item.inputs.diffuse,
            noReaction: item.inputs.noReaction,
            dyingBack: item.inputs.dyingBack,
            unchanged: item.inputs.unchanged,
            change: item.inputs.change
          };
        }
      );
    },
    async fetchBeetleOptions() {
      try {
        const response = await axios.get(
          `/api/Beetle/GetAll`
        );


        this.beetleItems = response.data;

        this.isLoading = false;
        this.hasError = false;
      } catch (error) {
        console.log(error);
        this.hasError = true;
      }
    },

    async fetchParasitOptions() {
      try {
        const response = await axios.get(
          `/api/Parasit/GetAll`
        );


        this.parasitItems = response.data;

        this.isLoading = false;
        this.hasError = false;
      } catch (error) {
        console.log(error);
        this.hasError = true;
      }
    },

    async fetchMushroomOptions() {
      try {
        const response = await axios.get(
          `/api/MushroomType/GetAll`
        );


        this.mushroomItems = response.data;

        this.isLoading = false;
        this.hasError = false;
      } catch (error) {
        console.log(error);
        this.hasError = true;
      }
    },

    getImageSrc(image) {
      if(image.nameBase64 != null){
         return  `data:image/${image.fileName};base64,${image.nameBase64}`;
      }
      else{
         return `data:image/${image.fileName};base64,${image.document}`;
      }
    }
  }
};
</script>
<style></style>
